import { AlmanacFile } from 'types'
import { IMediaFile } from './Types'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import { isVideo } from 'components/ImagePickerModal/utils'
import { partition, sortBy } from 'lodash'

interface GetMediaFilesOptions {
  prioritizeRecentUploads?: boolean
}

export const getMediaFiles = (
  files: AlmanacFile[],
  mediaTypes?: string,
  options: GetMediaFilesOptions = {},
): IMediaFile[] => {
  const { prioritizeRecentUploads = false } = options

  const defaultTypes = ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES
  const supportedTypes = mediaTypes || defaultTypes

  const mediaFiles = files
    .filter((file) => file.mime_type && supportedTypes.includes(file.mime_type) && file.source_url)
    .map((file) => {
      return {
        id: file.id,
        media_file_id: file.media_file_id,
        source_url: file.source_url,
        mime_type: file.mime_type,
        variants: file.variants,
        title: file.title,
        width: file.width,
        height: file.height,
        duration: file.duration,
        size: file.size,
        frame_rate: file.frame_rate,
        aspect_ratio: file.aspect_ratio,
        last_used_at: file.last_used_at,
        thumbnail_url: isVideo({ url: file.source_url, type: file.mime_type }) ? file.thumbnail_url : file.source_url,
      } as IMediaFile
    })
    .filter((file) => !!file.thumbnail_url)

  if (prioritizeRecentUploads) {
    const TEN_MINUTES = 10 * 60 * 1000
    const cutoff = Date.now() - TEN_MINUTES

    const timestamps = new Map(files.map((f) => [f.id, f.created_at ? new Date(f.created_at).getTime() : 0]))

    const getTime = (file: IMediaFile) => timestamps.get(file.id) || 0
    const isRecent = (file: IMediaFile) => getTime(file) > cutoff

    const [recent, older] = partition(mediaFiles, isRecent)
    const sortedRecent = sortBy(recent, (file) => -getTime(file))

    return [...sortedRecent, ...older]
  }

  return mediaFiles
}
